var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuidebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.66658V14.6666M9 6.66658C9 4.79974 9 3.86633 8.63667 3.15329C8.31708 2.52608 7.80717 2.01614 7.17997 1.69656C6.46692 1.33325 5.53351 1.33325 3.66667 1.33325H2.83333C2.36662 1.33325 2.13327 1.33325 1.95501 1.42408C1.79821 1.50398 1.67072 1.63146 1.59082 1.78826C1.5 1.96652 1.5 2.19988 1.5 2.66659V11.6666C1.5 12.1333 1.5 12.3667 1.59082 12.5449C1.67072 12.7018 1.79821 12.8292 1.95501 12.9091C2.13327 12.9999 2.36662 12.9999 2.83333 12.9999H5.2889C5.73906 12.9999 5.96413 12.9999 6.18178 13.0388C6.37496 13.0732 6.56342 13.1302 6.74326 13.2088C6.94587 13.2972 7.13314 13.422 7.50767 13.6718L9 14.6666M9 6.66658C9 4.79974 9 3.86633 9.36333 3.15329C9.68292 2.52608 10.1928 2.01614 10.82 1.69656C11.5331 1.33325 12.4665 1.33325 14.3333 1.33325H15.1667C15.6334 1.33325 15.8668 1.33325 16.045 1.42408C16.2018 1.50398 16.3293 1.63146 16.4092 1.78826C16.5 1.96652 16.5 2.19988 16.5 2.66659V11.6666C16.5 12.1333 16.5 12.3667 16.4092 12.5449C16.3293 12.7018 16.2018 12.8292 16.045 12.9091C15.8668 12.9999 15.6334 12.9999 15.1667 12.9999H12.7111C12.2609 12.9999 12.0358 12.9999 11.8182 13.0388C11.625 13.0732 11.4366 13.1302 11.2568 13.2088C11.0542 13.2972 10.8668 13.422 10.4923 13.6718L9 14.6666",
    stroke: "#363870",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidebook);
export default __webpack_public_path__ + "static/media/guidebook.c4a41a67548e8cf1f09c248ab0d181c5.svg";
export { ForwardRef as ReactComponent };